import _ from 'lodash';
import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../utils/logger';

export const MODULE_NAME = 'ANALYSIS_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const UNLOAD = namespaced('UNLOAD');
const LOAD_ANALYSIS_DETAILS = namespaced('LOAD_ANALYSIS_DETAILS');
const LOAD_ANALYSIS_DETAILS_OK = namespaced('LOAD_ANALYSIS_DETAILS_OK');
const LOAD_ANALYSIS_DETAILS_FAIL = namespaced('LOAD_ANALYSIS_DETAILS_FAIL');
const UNLOAD_DETAILS = namespaced('UNLOAD_DETAILS');
const REDELIVER_ALL_VAT_CODES = namespaced('REDELIVER_ALL_VAT_CODES');
const REDELIVER_ALL_VAT_CODES_OK = namespaced('REDELIVER_ALL_VAT_CODES_OK');
const REDELIVER_ALL_VAT_CODES_FAIL = namespaced('REDELIVER_ALL_VAT_CODES_FAIL');

export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    LOAD_ANALYSIS_DETAILS,
    LOAD_ANALYSIS_DETAILS_OK,
    LOAD_ANALYSIS_DETAILS_FAIL,
    UNLOAD,
    UNLOAD_DETAILS,
    REDELIVER_ALL_VAT_CODES,
    REDELIVER_ALL_VAT_CODES_OK,
    REDELIVER_ALL_VAT_CODES_FAIL
};

export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('updateSubStateFromAction: ', action, state );
    const getNewState = (action, state) => {
      switch (action.type) {
        case LOAD:
          return  Object.assign({}, state, {loading: true, error: null});
        case LOAD_OK:
          return Object.assign({}, state, {data: action.response, loading: false, error: null});
        case LOAD_FAIL:
          return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
        case LOAD_ANALYSIS_DETAILS:
          return  Object.assign({}, state, {loading: false, error: null});
        case LOAD_ANALYSIS_DETAILS_OK:
          return Object.assign({}, state, {analysisDetails: action.response, loading: false, error: null});
        case LOAD_ANALYSIS_DETAILS_FAIL:
          return Object.assign({}, state, {analysisDetails: undefined, loading: false, error: action.error});
        case UNLOAD:
          return Object.assign({}, state, {data: undefined, loading: false, error: undefined});  
        case UNLOAD_DETAILS:
          return Object.assign({}, state, {analysisDetails: undefined});  
        case REDELIVER_ALL_VAT_CODES:
          return Object.assign({}, state, {loading: true, error: null, redeliverAllResponse: null}); 
        case REDELIVER_ALL_VAT_CODES_OK:
          return Object.assign({}, state, {loading: false, error: null, redeliverAllResponse: action.response});
        case REDELIVER_ALL_VAT_CODES_FAIL:
          return Object.assign({}, state, {loading: false, error: action.error, redeliverAllResponse: null});
        default:
          return state;
      }
    };
    const newState = getNewState(action, state);
    log.debug('updateSubStateFromAction:  newState', newState );
    return newState;
};

export const API = {
    doLoad: (params) => {      
      return (dispatch, getState) => {
        dispatch({type: LOAD});
        return CLIENT.getAnalysis(params)
          .then((response) => {
            dispatch({type: LOAD_OK, response: response});
          })
          .catch((error) => {
            dispatch({type: LOAD_FAIL, error});
          });
      };
    },

    doLoadAnalysisDetails: (params, callback=()=>{}) => {
      return (dispatch) => {
        dispatch({type: LOAD_ANALYSIS_DETAILS});
        return CLIENT.getAnalysisDetails(params)
        .then((response) => {
          dispatch({type: LOAD_ANALYSIS_DETAILS_OK, response: response});
          callback(null, response);
        })
        .catch((error) => {
          dispatch({type: LOAD_ANALYSIS_DETAILS_FAIL, error: error});
          callback(error, null);
        });
      };
    },

    doUnload: () => {
        return (dispatch, getState) => {
            dispatch({type: UNLOAD});
        };
    },

    doUnloadDetails: () => {
      return (dispatch, getState) => {       
        dispatch({type: UNLOAD_DETAILS});
      };
    },

    clearAllAnalysisErrors: () => {
      return (dispatch, getState) => {       
        log.clearAllDictionaryErrors();
      };
    },

    redeliverAllVATCodes: ( apiParams={}, callback=()=>{}) => {
      return (dispatch, getState) => {
        log.clearAllDictionaryErrors();
        dispatch({type: REDELIVER_ALL_VAT_CODES});
        return CLIENT.redeliverAllVATCodes(apiParams)
          .then((response) => {
            log.debug('doRedeliverAllVATCodes(): succeeded ', response);
            //Check for failures
            if(response && !_.isEmpty(response.failures)) {
              log.setDictionaryMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_ERROR_WITH_VAT_CODES);
              dispatch({type: REDELIVER_ALL_VAT_CODES_FAIL, response});
              callback(response, null);
            }            
            else {
              log.setDictionaryMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_SUCCESS);
              dispatch({type: REDELIVER_ALL_VAT_CODES_OK, response});
              callback(null, response);
            }
          })
          .catch((error) => {
            log.debug('doRedeliverAllVATCodes(): error', error );
            log.setDictionaryMessage(ALL_MESSAGES.VAT_CODES_REDELIVER_ERROR_WITH_VAT_CODES);
            dispatch({type: REDELIVER_ALL_VAT_CODES_FAIL, error});
            callback(error, null);
          });
      };
    }
};

export default API;

